import { render } from "./PartnersView.vue?vue&type=template&id=7e998c03&scoped=true"
import script from "./PartnersView.vue?vue&type=script&lang=js"
export * from "./PartnersView.vue?vue&type=script&lang=js"

import "./PartnersView.vue?vue&type=style&index=0&id=7e998c03&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e998c03"]])

export default __exports__